import * as React from 'react';
import { SchuelerAside } from '../schueler/SchuelerAside';
import { SchuelerTopBar } from '../schueler/SchuelerTopBar';
import { Store } from '../store/Store';
import { StoreContext } from 'src/pagepart/utils';
import { BasicPortalStructure } from '../layout/BasicPortalStructure';

export interface Props {
  img?: string;
}

export class BasicAuthBox extends React.Component<Props, {}> {
  render() {
    const { children } = this.props;
    return (
      <div className="d-flex flex-column flex-root" style={{ marginTop: 25 }}>
        <>
          <style global jsx>{`
            @media (max-width: 991.98px) {
              .header-mobile-fixed .content {
                padding-top: 0px;
              }
            }

            .pulse {
              box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
              animation: pulse 2s infinite;
            }

            @keyframes pulse {
              0% {
                box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
              }
              70% {
                box-shadow: 0 0 8px 8px rgba(52, 69, 229, 0.3);
              }
              100% {
                box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
              }
            }
          `}</style>
          {/*begin::Login*/}
          <div className="login login-4 login-forgot-on d-flex flex-row-fluid" id="kt_login">
            <div
              className="d-flex flex-center flex-row-fluid bgi-size-cover bgi-position-top bgi-no-repeat"
              style={{ backgroundImage: 'url("/static/dist7/assets/media/bg/bg-3.jpg")' }}
            >
              <div className="login-form text-center p-7 position-relative overflow-hidden">
                {/*begin::Login Header*/}
                <div className="d-flex flex-center mb-15">
                  <a href="#">
                    <img
                      src={this.props.img || '/images/schlaukopf_neu.svg'}
                      alt=""
                      className="max-h-75px"
                      style={{ width: 75, height: 75 }}
                    />
                  </a>
                </div>
                {/*end::Login Header*/}

                {children}
              </div>
            </div>
          </div>
          {/*end::Login*/}
        </>
      </div>
    );
  }
}
